import type { IOrganizationSimpleJSON } from 'external-api-types';
import type { OrganizationsActions } from '../../actions/org';

export interface State {
    entries?: IOrganizationSimpleJSON[];
    isFetching: boolean;
}

const getDefaultState = (): State => ({
    entries: undefined,
    isFetching: true
});

const organizationsReducer = (state = getDefaultState(), action: OrganizationsActions | null): State => {
    switch (action?.type) {
        case 'SET_ORGANIZATIONS': {
            return {
                ...state,
                entries: action.data.entries,
                isFetching: action.data.isFetching
            };
        }

        default: {
            return state;
        }
    }
};

export default organizationsReducer;
